import React, { useState, useEffect, memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useQueryClient } from 'react-query';
import * as Sentry from '@sentry/browser';
import { COLORS, Icon } from '@livecommerce/design-system';
import { styled } from '@linaria/react';

import { useFirebase } from 'components/Firebase/index.js';
import { setOrUpdateAuthUser as setOrUpdateAuthUserAction } from 'actions/session.js';

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const defaultSentryUser = { id: null, username: null };

const withAuthentication = (Component) => {
  const WrappedComponent = () => {
    const firebase = useFirebase();
    const dispatch = useDispatch();
    const setOrUpdateAuthUser = useCallback((payload) => dispatch(setOrUpdateAuthUserAction(payload)), [dispatch]);
    const [isAuthenticating, setAuthentication] = useState(true);
    const queryClient = useQueryClient();

    useEffect(() => {
      Sentry.configureScope((scope) => scope.setUser(defaultSentryUser));
      const listener = firebase.onAuthUserListener(
        (authUser) => {
          setOrUpdateAuthUser(authUser);
          setAuthentication(false);
          Sentry.configureScope((scope) => scope.setUser(defaultSentryUser));
        },
        () => {
          queryClient.clear();
          setAuthentication(false);
          setOrUpdateAuthUser(null);
          Sentry.configureScope((scope) => scope.setUser(defaultSentryUser));
        },
      );
      return () => listener();
    }, []);

    if (isAuthenticating) {
      return (
        <LoaderContainer>
          <Icon name="logoHorizontal" color={COLORS.white} height={42} width={168} />
        </LoaderContainer>
      );
    }
    if (isAuthenticating) return null; //<Loader />;
    const combinedProps = { firebase, onSetAuthUser: setOrUpdateAuthUser, isAuthenticating };
    return <Component {...combinedProps} />;
  };

  return memo(WrappedComponent);
};

export default withAuthentication;
